import { render, staticRenderFns } from "./event_dropdown.vue?vue&type=template&id=7219ee95"
import script from "./event_dropdown.vue?vue&type=script&lang=js"
export * from "./event_dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports